"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _FiatWithdrawFormComponent = _interopRequireDefault(require("./FiatWithdrawFormComponent"));
var _sidePaneActions = require("../../../../redux/actions/sidePaneActions");
var _withdrawActions = require("../../../../redux/actions/withdrawActions");
var _modalActions = require("../../../../redux/actions/modalActions");
var _positionActions = require("../../../../redux/actions/positionActions");
var _kycLevelsSelectors = require("../../../../redux/selectors/kycLevelsSelectors");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableWithdraw = _kycVerificationLevel.disableWithdraw;
  return {
    disableWithdraw: disableWithdraw,
    fee: state.withdraw.withdrawFee,
    withdrawInfo: state.withdraw,
    products: state.apexCore.product,
    allowTransfer: _config["default"].global.allowTransfer
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectPosition: function selectPosition(productId) {
      return dispatch((0, _positionActions.selectPosition)(productId));
    },
    verificationOnClick: function verificationOnClick() {
      return dispatch((0, _sidePaneActions.closeSidePane)());
    },
    confirmWithdraw: function confirmWithdraw(payload) {
      return dispatch((0, _withdrawActions.createWithdrawTicket)(payload));
    },
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplates)(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(ProductId, AccountProviderId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplate)(ProductId, parseInt(AccountProviderId)));
    },
    getWithdrawFee: function getWithdrawFee(productId, amount, AccountProviderId) {
      return dispatch((0, _withdrawActions.getWithdrawFee)(productId, amount, AccountProviderId));
    }
  };
};
var FiatWithdrawForm = (0, _reduxForm.reduxForm)({
  form: 'createFiatWithdraw',
  onSubmit: function onSubmit(payload, dispatch, _ref) {
    var fee = _ref.fee,
      template = _ref.withdrawInfo.template;
    return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_FIAT_WITHDRAW, {
      payload: payload,
      fee: fee,
      template: template
    }));
  }
})(_FiatWithdrawFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FiatWithdrawForm);